import React, { useEffect, useRef, useState } from "react";
import ExtractBar from "../ExtractBar/ExtractBar";
import Modal from "../Modal";
import ModalFamily from "../ModalFamily/ModalFamily";

import SummaryStatusBar from "../SummaryStatusBar/SummaryStatusBar";
import InfinityValueContainer from "../InfinityValueContainer/InfinityValueContainer";
import AccordionTable from "../AccordionTable/AccordionTable";
import { observer } from "mobx-react";
import {
  downloadPDFFile,
  exportExcel,
  getCurrentDate,
  getPrintDate,
  //printDocument,
  showDashIfZero,
} from "../../utils/functions";
//import PdfTable from "../PdfTable/PdfTable";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import * as Scroll from "react-scroll";
import AuthStore from "../../store/AuthStore";
import { useLocation, useOutletContext, useParams } from "react-router";
import Header from "../Header/Header";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import { infinityAssetClassSheetName } from "../../utils/constants";
import PageTitle from "../PageTitle/PageTitle";
import PageHeading from "../PageHeading/PageHeading";
import { homePageRoute } from "../../utils/constants";

const InfinityHoldings = observer(({ data }) => {
  const [selectedMember, setSelectedMember] = useState("0");
  const [openFamilyModal, setOpenFamilyModal] = useState(false);
  //const [ isLoading , i ] = useState(true);
  const portfolioPathRef = useRef();
  // const [isBackPressed, setIsBackPressed] = useState(false);

  const allocationArray = UserStore.portfolio?.allocationSummaryInfinity;
  const [othersModalOpen, setOthersModalOpen] = useState(false);
  const [tooltipModalOpen, setToolTipModalOpen] = useState(false);

  const context = useOutletContext();

  const location = useLocation();
  const { instrumentId, lastMeasureId } = useParams();

  const pdfTableId = "infinityholding";

  let modifiedExcelAssetClassData = [];
  const excelAssetClassesData = UserStore.excelAssetClassesDataInfinity;
  const othersData = UserStore.othersInfinityHolding;
  excelAssetClassesData?.forEach((assetClass) => {
    modifiedExcelAssetClassData.push({ ...assetClass, primary: true });
    assetClass.instrumentVehiclesList.forEach((subAssetClass) => {
      let subAssetObj = {
        asset_class: subAssetClass.assetClass.name || "-",
        allocation: showDashIfZero(subAssetClass.allocation_percentage),
        curr_value:
          showDashIfZero(
            Number(
              subAssetClass.investmentreturn.current_value.actual_value,
            ).toFixed(2),
          ) || "-",
        inv_value:
          showDashIfZero(
            Number(
              subAssetClass.investmentreturn.invested_value.actual_value,
            ).toFixed(2),
          ) || "-",
        int_div:
          showDashIfZero(
            Number(
              subAssetClass.investmentreturn.int_div.amount.actual_value,
            ).toFixed(2),
          ) || "-",
        unrealised_gain:
          showDashIfZero(
            Number(
              subAssetClass.investmentreturn.unrealised_gain.amount
                .actual_value,
            ).toFixed(2),
          ) || "-",
        unrealised_percentage:
          Number(
            subAssetClass.investmentreturn.unrealised_gain.percentage,
          ).toFixed(2) || "-",
        realised_gain:
          showDashIfZero(
            Number(
              subAssetClass.investmentreturn.realised_gain.amount.actual_value,
            ).toFixed(2),
          ) || "-",
        irr: showDashIfZero(subAssetClass.investmentreturn.irr) || "-",
      };
      modifiedExcelAssetClassData.push({ ...subAssetObj });
    });
  });
  modifiedExcelAssetClassData.push({
    asset_class: othersData?.assetClass?.name,
    allocation: "-",
    curr_value: String(
      Number(
        othersData?.investmentreturn?.current_value?.actual_value,
      )?.toFixed(2),
    ),
    inv_value: "-",
    unrealised_gain: "-",
    realised_gain: "-",
    irr: "-",
    primary: true,
  });

  const userHydrated = UserStore.isHydrated;
  const performanceHydrated = PerformanceStore.isHydrated;
  const loadingScreen = AuthStore.isLoadingFullScreen;
  const assetClass = UserStore?.portfolio?.clientAssetClassInfinity;

  // const handlePdf = () => {
  //   printDocument(pdfTableId, {
  //     width: 650,
  //     height: 600,
  //     name: `Infinity Portfolio Summary - ${
  //       UserStore.getData === "fam"
  //         ? UserStore.userData?.family_name
  //         : UserStore.userData?.full_name
  //     }`,
  //   });
  // };

  const pdfTableColumns = [
    { label: "Asset Class", key: "asset_class" }, // Top level data
    { label: "Allocation(%)", key: "allocation" },
    {
      label: "Current Value",
      key: "curr_value",
    },
    { label: "Inv Value", key: "inv_value" }, // Top level data
    { label: "Int/Div", key: "int_div" },
    { label: "Unrealised Gain", key: "unrealised_gain" }, // Top level data
    { label: "Unrealised(%)", key: "unrealised_percentage" },
    { label: "Realised Gain", key: "realised_gain" },
    { label: "IRR(%)", key: "irr" },
  ];

  useEffect(() => {
    return () => {
      UserStore.setAssetTabsData([]);
      // infinityAbort.abort();
      // //!isNavigated && setIsInfinityUnmounted(true);
      // UserStore.setAssetTabsData([]);
    };
  }, []);

  useEffect(() => {
    if (
      !AuthStore.isLoadingFullScreen &&
      UserStore.isHydrated &&
      PerformanceStore.isHydrated
    ) {
      setTimeout(() => {
        const itemToScroll = document.getElementById(
          `${UserStore.selectedRefIdInfinity}`,
        );
        if (itemToScroll) {
          Scroll.animateScroll.scrollTo(
            itemToScroll?.getBoundingClientRect().top,
            {
              isDynamic: true,
              duration: 1700,
              smooth: true,
              delay: 100,
            },
          );
        }
      }, 500);
    }
  }, [
    // UserStore.isHydrated,
    // PerformanceStore.isHydrated,
    // AuthStore.isLoadingFullScreen,
    // UserStore?.portfolio?.clientAssetClass,
    userHydrated,
    performanceHydrated,
    loadingScreen,
    assetClass,
  ]);

  const setPortfolioPath = () => {
    const portfolioPath = UserStore.portfolioPath;
    if (
      !portfolioPath?.[portfolioPath?.length - 1]?.show?.includes(
        "Infinity Holdings",
      )
    ) {
      UserStore.setPortfolioPath(
        {
          path: `/${
            location?.pathname?.includes("portfolio")
              ? "portfolio"
              : homePageRoute
          }/instrument/infinity/${lastMeasureId}`,
          show: `Infinity Holdings`,
          state: {
            from: `${
              location?.pathname?.includes("portfolio")
                ? "portfolio"
                : homePageRoute
            }`,
          },
        },
        true,
      );
    }
  };

  portfolioPathRef.current = setPortfolioPath;

  // const handleBreadClick = (index, data) => {};

  const getReportsSheetName = () => {
    return `${infinityAssetClassSheetName} - INR`;
  };

  useEffect(() => {
    if (UserStore.isHydrated) {
      portfolioPathRef.current();
    }
  }, [userHydrated]);

  useEffect(() => {
    PerformanceStore.setCurrentLoader("infinityMainLoader");
    PerformanceStore.setPerformanceLoader("infinityMainLoader", true);
    const abortController = new AbortController();
    const { signal } = abortController;
    const pathname = location.pathname;
    if (UserStore.isHydrated && PerformanceStore.isHydrated) {
      const pathArray = pathname.split("/");
      UserStore.setRef(Number(instrumentId), "subasset");
      AuthStore.updateLoadingFullScreen(true);
      UserStore.setNormalHybirdFlow(true);
      UserStore.setInfinity("1");
      UserStore.setMesurementId(UserStore.forThirdLevelMeasureId);
      PerformanceStore.setCurrentLoader("infinityMainLoader");
      PerformanceStore.setPerformanceLoader("infinityMainLoader", true);
      window.scrollTo(0, 0);
      UserStore.populateInfinityPortfolio(
        pathArray[4],
        true,
        signal,
        //infinityAbort.signal
      );
      UserStore.infinityClick(2 + 1);
    }
    return () => {
      abortController.abort();
    };
  }, [UserStore.isHydrated, PerformanceStore.isHydrated]);

  return (
    <>
      <PageTitle title={"Infinity Holdings"} />
      {!UserStore.isHydrated || PerformanceStore.infinityMainLoader ? (
        <LoadingScreen />
      ) : (
        <>
          <Header type={context.type} />
          <div className="direct_equity_out_container">
            {!location.pathname.includes("_portfolio") && (
              <BreadCrumb
                locationArr={UserStore.portfolioPath}
                // clickFunction={(index, data) => handleBreadClick(index, data)}
                parentName={"portfolio"}
              />
            )}

            <div className="infinity_holdings_out">
              <div className="inifinity_select_bar">
                <PageHeading
                  headingClass="infinity_select_title"
                  headingText={data?.title || "Infinity Holdings"}
                />
              </div>
              <div className="inifinity_data_container">
                <InfinityValueContainer
                  data={data?.data}
                  tooltipModalOpen={tooltipModalOpen}
                  setToolTipModalOpen={(data) => {
                    setToolTipModalOpen(data);
                  }}
                />
                <div className="lackvalue"></div>
                <ExtractBar
                  extractExcel={() => {
                    const columns = [
                      { label: "Asset Class", key: "asset_class" }, // Top level data
                      { label: "Allocation(%)", key: "allocation" },
                      {
                        label: "Current Value",
                        key: "curr_value",
                      },
                      { label: "Inv value", key: "inv_value" }, // Top level data
                      { label: "Int/Div", key: "int_div" },
                      { label: "Unrealised Gain", key: "unrealised_gain" }, // Top level data
                      { label: "Unrealised(%)", key: "unrealised_percentage" },
                      { label: "Realised Gain", key: "realised_gain" },
                      { label: "IRR(%)", key: "irr" },
                    ];
                    exportExcel({
                      sheetname: getReportsSheetName(),
                      columns,
                      data: modifiedExcelAssetClassData,
                      reportDetails: {
                        relatioshipManager: UserStore?.exportDetails?.find(
                          (item) => item.role === "RM",
                        )?.name,
                        serviceManager: UserStore?.exportDetails?.find(
                          (item) => item.role === "CXO",
                        )?.name,
                        date: getPrintDate(
                          UserStore.portfolio?.clientPortfolioReturn
                            ?.as_of_date,
                        ),
                        clientName:
                          UserStore.getData === "fam"
                            ? UserStore.userData?.family_name
                            : UserStore.userData?.full_name,
                      },
                      exportFrom: "portfolioPage1",
                      excelName: `Infinity Portfolio Summary - ${
                        UserStore.getData === "fam"
                          ? UserStore.userData?.family_name
                          : UserStore.userData?.full_name
                      } -  ${getCurrentDate()}`,
                      customSheetName: infinityAssetClassSheetName,
                    });
                  }}
                  extractPdf={() => {
                    // handlePdf();
                    // return;

                    return downloadPDFFile({
                      headerName: getReportsSheetName(),
                      fileId: pdfTableId,
                      name: `Infinity Portfolio Summary - ${
                        UserStore.getData === "fam"
                          ? UserStore.userData?.family_name
                          : UserStore.userData?.full_name
                      }`,
                      columns: pdfTableColumns,
                      data: modifiedExcelAssetClassData,
                    });
                  }}
                  title={"Allocation Summary"}
                />

                {allocationArray && (
                  <SummaryStatusBar dataSeries={allocationArray} />
                )}
                <AccordionTable
                  setOthersModalOpen={(data) => setOthersModalOpen(data)}
                  othersModalOpen={othersModalOpen}
                  tooltipModalOpen={tooltipModalOpen}
                  setToolTipModalOpen={(data) => setToolTipModalOpen(data)}
                  page={"infinity"}
                />
              </div>
            </div>

            <Modal
              onClose={() => setOpenFamilyModal(false)}
              open={openFamilyModal}
              title={"Select Family Member"}
              width={"810px"}
            >
              <ModalFamily
                setSelectedMember={(id) => setSelectedMember(id)}
                selectedMember={selectedMember}
                onClose={() => setOpenFamilyModal(false)}
              />
            </Modal>
            {/* <PdfTable
              headerName={getReportsSheetName()}
              columns={pdfTableColumns}
              data={modifiedExcelAssetClassData}
              id={pdfTableId}
            /> */}
          </div>
        </>
      )}
    </>
  );
});

export default InfinityHoldings;
